import angular from 'angular';
import APIV5 from '~/models/api';

/* globals Knitiv */

export default class MenuDatabaseController {
	/* @ngInject */
	/**
	 * @param {Knitiv.RootScope} $rootScope
	 * @param {Knitiv.UserModel} User
	 */
	constructor(
		$rootScope,
		User,
	) {
		this.$rootScope = $rootScope;
		this.User = User;
		/**
		 * @type {Database['kid'] | undefined}
		 */
		this.database = undefined;
		/**
		 * @type {Database[]}
		 */
		this.databases = [];

		this.shouldShow = false;

		this.isLoaded = false;

		$rootScope.$on('User.login', () => {
			this.loadDatabases();
		});

		if ($rootScope.context?.token) {
			this.loadDatabases();
		}
	}

	dbName() {
		return this.$rootScope.context?.db?.name ?? '---';
	}

	async loadDatabases() {
		// reset list
		this.databases.length = 0;

		const workspaces = await APIV5.instance.workspaceList({
			tokenid: this.$rootScope.context?.token.id,
		}, {
			id: 'menu-database.load-databases',
		});

		for (const [environmentKID, environment] of Object.entries(workspaces.workspaces.env_list)) {
			for (const database of environment.database_list) {
				this.databases.push({
					env: environmentKID,
					name: database.name,
					kid: database.kid,
					dsnasso: database.dsnasso_kid,
				});
			}
		}

		this.database = this.$rootScope.context?.db.kid;

		if (this.databases.length > 1) {
			this.shouldShow = true;
		}
		this.isLoaded = true;
	}

	/**
	 *
	 * @param {Database} database
	 */
	async switchTo(database) {
		if (this.database === database.kid) {
			return;
		}

		const response = await APIV5.instance.raw('TokenChange', {
			tokenid: this.$rootScope.context?.token.id,
			dsnasso: database.dsnasso,
		});

		this.User.set(response).saveToken();
		window.location.assign('/');
	}
}

/**
 * @typedef {Object} Database
 * @property {string} env
 * @property {string} name
 * @property {string} kid
 * @property {string} dsnasso
 */

// eslint-disable-next-line angular/function-type,angular/controller-name
angular.module('app')
	.controller('MenuDatabaseCtrl', MenuDatabaseController);
